export enum NotificationTypeEnum {
  SMS = 'SMS',
  WHATSAPP = 'WHATSAPP'
}

export interface INotificationPreferencesRequest {
  preferences: {
    schedule_notification_type: NotificationTypeEnum | null
  }
}

export interface IPhoneNotificationData {
  data: NotificationTypeEnum | null
  isLoading?: boolean
  isSuccess?: boolean
  updatePhoneNotification: (data: NotificationTypeEnum) => void
}